import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/safe-driving-vDSP/SafeDrivingContents/.eu';
import Kr from '@di-shared/features/safe-driving-vDSP/SafeDrivingContents/.kr';

export interface SafeDrivingContentsProps {
  vin: string;
}

export default function SafeDrivingContents({vin}: SafeDrivingContentsProps) {
  return (
    <>
      <Environment.Kr>
        <Kr vin={vin} />
      </Environment.Kr>
      <Environment.Eu>
        <Environment.Hyundai>
          <Eu vin={vin} />
        </Environment.Hyundai>
        <Environment.Genesis>
          <Eu vin={vin} />
        </Environment.Genesis>
      </Environment.Eu>
    </>
  );
}
